import React from 'react';

class CircleTimesIcon extends React.Component {
  render() {
    return (
      <svg
        id="Layer_1"
        width="22"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 37.3 37.3"
      >
        <path d="M18.7,35.6a17,17,0,1,1,16.9-17A17,17,0,0,1,18.7,35.6Zm0-32a15.1,15.1,0,1,0,15,15.1A15.15,15.15,0,0,0,18.7,3.6Z" />
        <rect
          x="7.38"
          y="17.68"
          width="22.6"
          height="1.9"
          transform="translate(-7.7 18.65) rotate(-44.98)"
        />
        <rect
          x="17.73"
          y="7.4"
          width="1.9"
          height="22.6"
          transform="translate(-7.75 18.68) rotate(-45)"
        />
      </svg>
    );
  }
}

export default CircleTimesIcon;
